module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiboldSemiCn.6dd3ed6.ttf";